import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Header from "components/Header";
import styles from "../Help/style.module.scss";
import MainLayout from "layouts/Main";
import ApiKeyInput from "components/ApiKeyInput";
import { generateAPIToken, fetchAPITokenAPI } from "services/api/userSetting";
import Button from "components/Button";
import { showErrorMessage } from "helpers/toastMessage";
import { routes } from "constants/routes";
import { useIntegrations } from "hooks/useIntegrations";

export default function API() {
  const { canManageExternalAPI } = useIntegrations();
  const [apiToken, setApiToken] = useState("");
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!canManageExternalAPI) return;

    async function getApiToken() {
      try {
        setIsFetching(true);
        const res = await fetchAPITokenAPI();
        setApiToken(res?.data?.token);
      } catch (e) {
        showErrorMessage("Failed to get API token. Please try again later.");
      } finally {
        setIsFetching(false);
      }
    }

    getApiToken();
  }, [canManageExternalAPI]);

  const handleGenerateAPIToken = useCallback(async () => {
    if (!canManageExternalAPI) return;

    try {
      setIsFetching(true);
      const res = await generateAPIToken();
      setApiToken(res?.data?.token);
    } catch (e) {
      showErrorMessage("Failed to generate API token. Please try again later.");
    } finally {
      setIsFetching(false);
    }
  }, [canManageExternalAPI]);

  if (!canManageExternalAPI) {
    return <Navigate to={routes.SETTINGS} replace />;
  }

  return (
    <MainLayout
      desktopTitle="API"
      customHeader={<Header label="API" headerIcon=" " isHideDesktop />}
      hideNavigation
      className={styles.helpContainer}>
      <p>HaulPay API allows you to integrate with our platforms</p>
      <p>
        For more information, Please refer to our{" "}
        <a
          className="text-primary"
          onClick={() => {
            if (window) {
              const newWindow = window.open("http://docs.comfreight.com/", "_blank");
              if (newWindow) {
                newWindow.focus();
              } else {
                showErrorMessage(
                  "Failed to open new window. Check your browser settings for pop-up blocking."
                );
              }
            }
          }}>
          API documentation
        </a>
        .
      </p>
      <div className="flex flex-col gap-3 justify-end">
        <ApiKeyInput label="API Key" value={apiToken} isFetching={isFetching} />
        <div className="flex justify-end">
          <Button onClick={handleGenerateAPIToken}>Generate New API Key</Button>
        </div>
      </div>
    </MainLayout>
  );
}
